<template>
    <div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Import Student Outstanding Fees</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <a href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/Outstanding_Import.csv">
                    <v-btn color="white" rounded outlined class="ma-2 downbtn">
                        Download CSV format
                        <v-icon right dark>mdi-cloud-download</v-icon>
                    </v-btn>
                </a>
            </v-toolbar>

            <v-row dense justify="center">
                <v-col sm="4">
                    <v-file-input class="mt-2" dense placeholder="CSV of student data" prepend-icon="mdi-file" label="Student Data" show-size flat rounded outlined v-model="file"></v-file-input>
                </v-col>
                <v-col sm="2">
                    <v-btn class="button" @click="submitFile">Submit</v-btn>
                </v-col>
            </v-row>
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Add Student Outstanding Fees</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row dense justify="center">
               <!-- <v-col sm="4">
                    <v-icon color="error">*</v-icon>
                    <v-text-field outlined rounded color="#0F2027" dense placeholder="Enter PRN No." v-model="grno_or_app_form_no" type="text" hint="For example :: 121/111"></v-text-field>
                </v-col> -->
                  <v-col cols="12" sm="6" md="6">
                        <v-combobox class="mt-2" v-model="registration_no" rounded :items="stud_list" label="Select Student" item-text="name" outlined dense prepend-icon="mdi-account-child-circle"></v-combobox>
                    </v-col>
                <v-col sm="2">
                    <v-btn :disabled="!registration_no" class="button" @click="getDetails()" :loading="proceed_btn_load">Proceed</v-btn>
                </v-col>
            </v-row>
        </v-card>

        <v-row dense v-if="show == true">
            <span class="slide"> Note* : Please enter amount in negative if revisable.</span>
        </v-row>
        <v-card class="box" v-if="new_outstanding_field">
            <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                    <v-select rounded :items="academic_year_list" label="Academic Year" item-text="academicyear" item-value="ay_id" outlined dense v-model="ay"></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-text-field rounded label="" placeholder="Enter Outstanding fees" hint="For Example 2000 or -2000" type="number" class="padding-bot" outlined dense v-model="out_fees"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-btn :disabled="!out_fees" class="button" @click="assignOutFees()" :loading="proceed_btn_load">Apply</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <!-- <div v-for="notice in searchByTitleOrDescription" :key="notice.id"> -->

        <v-card dense v-if="show == true && get_outstanding_fees_list.length != 0" class="box">
            <!-- <v-card v-if="get_outstanding_fees_list.length != 0"> -->
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Current Academic Year : {{ current_ay }} </v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text>
                <v-data-table :headers="headers" :items="get_outstanding_fees_list" class="elevation-1 mytable" dense :search="search">
                    <template v-slot:item.amount="{ item }">
                        <div>
                            <!-- <v-checkbox v-model="selected_install" dense color="success"></v-checkbox> -->
                            <!-- <v-checkbox multiple class="mr-5" dense v-model="selected_install" :value="item.fees_component_id"></v-checkbox> -->
                            <v-text-field class="mt-3" outlined rounded color="#0F2027" dense placeholder="Enter amount" v-model="item.amount" hint="For example :: 2000 or -2000"></v-text-field>
                        </div>
                    </template>

                    <template v-slot:item.action="{ item }">
                        <div>
                            <v-btn @click="putEntry(item.amount,item.id)" class="mt-1 button" :disabled="item.amount == null || item.amount == ''"> Update </v-btn>
                        </div>
                    </template>
                    <template v-slot:item.due_date="{ item }">
                        <div>
                            <!-- <v-menu v-model="menu12" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field dense outlined rounded v-model="item.due_date" label="Due Date"  prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="item.due_date" @input="menu12 = false"></v-date-picker>
                            </v-menu> -->
                            Already Assigned Due Date -{{ item.due_date }}
                            <input id="datePickerId" type="date" v-model="item.due_date" />
                        </div>
                    </template>
                    <template v-slot:item.action_due_date="{ item }">
                        <div>
                            <v-btn class="mt-1 button" :disabled="item.due_date == null || item.due_date == ''"  @click="updateStudentOutstandingfees_due_date_fine(item.due_date, item.id)"> Save / Update Due Date </v-btn>
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-card class="box" v-if="success_records_list != '' || failed_record_list.length != 0">
            <v-toolbar dense flat color="white">
                <v-radio-group class="mt-6" v-model="row" row>
                    <v-radio label="Success Records" value="success" color="success" @click="row='success'"></v-radio>
                    <v-radio label="Failed Records" value="fail" color="error" @click="row='fail'"></v-radio>
                </v-radio-group>
            </v-toolbar>
            <span v-if="row=='success'">
                <v-toolbar dense class="toolbar" flat color="white">
                    <v-toolbar-title>Successful Records</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <download-excel class="mr-2 pb-3 pt-2" :data="success_records_list" :fields="import_table_fields" worksheet="Imported_Student_List" name="Imported_student_list.xls">
                        <v-btn outlined rounded color="white"> <v-icon>mdi-file-excel</v-icon> Export </v-btn>
                    </download-excel>
                </v-toolbar>
                <br />
                <v-data-table dense :headers="status_headers" :items="success_records_list" sort-by class="elevation-1 mytable" :search="search"></v-data-table>
            </span>
            <span v-if="row=='fail'">
                <v-toolbar dense class="toolbar" flat color="white">
                    <v-toolbar-title>Failed Records</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <download-excel class="mr-2 pb-3 pt-2" :data="failed_record_list" :fields="import_table_fields" worksheet="Failed_Student_List" name="Failed_student_list.xls">
                        <v-btn outlined rounded color="white"> <v-icon>mdi-file-excel</v-icon> Export </v-btn>
                    </download-excel>
                </v-toolbar>
                <br />
                <v-data-table dense :headers="status_headers" :items="failed_record_list" sort-by class="elevation-1 mytable" :search="search"></v-data-table>
            </span>
        </v-card>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
        data: () => ({
            file: null,
            child_info: null,
            overlay: false,
            children: [],
            academic_year_list: [],
            selected_install: [],
            get_outstanding_fees_list: [],
            already_selected_component_selection_list: [],
            success_records_list: [],
            failed_record_list: [],
            registration_no: null,
            stud_list:[],
            ay: null,
            menu12: false,
            row: "success",
            out_fees: null,
            new_outstanding_field: false,
            proceed_btn_load: false,
            amount: null,
            status_headers: [
                {
                    text: "Registration No.",
                    value: "reg_no",
                },
                {
                    text: "Academic Year",
                    align: "left",
                    sortable: false,
                    value: "academic_year",
                },
                {
                    text: "Fees Ammount",
                    align: "left",
                    sortable: true,
                    value: "amount",
                },
                {
                    text: "Reason",
                    align: "left",
                    sortable: true,
                    value: "reason",
                },
            ],
            import_table_fields: {
                "Registration No.": "reg_no",
                "Academic Year": "academic_year",
                "Outstanding Amount": "amount",
                Reason: "reason",
            },
            headers: [
                {
                    text: "Academic Year",
                    align: "left",
                    sortable: false,
                    value: "ofAcademicYear",
                },
                {
                    text: "Fees Ammount",
                    align: "left",
                    sortable: true,
                    value: "amount",
                },
                { text: "Actions", value: "action", sortable: false },
                {
                    text: "Due Date",
                    align: "left",
                    sortable: true,
                    value: "due_date",
                },
                { text: "Actions", value: "action_due_date", sortable: false },
            ],

            already_selected_headers: [
                {
                    text: "Academic Year",
                    align: "left",
                    sortable: false,
                    value: "ofAcademicYear",
                },
                {
                    text: "Fees Ammount",
                    align: "left",
                    sortable: true,
                    value: "amount",
                },
                { text: "Actions", value: "action", sortable: false },
            ],

            show: false,
            selected_children: "",
            child_notice: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            current_ay: "",
            search: "",
            s3url: "",
        }),
        watch: {
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },

        methods: {
            clear() {
                this.show = false;
                this.new_outstanding_field = false;
                this.get_outstanding_fees_list = [];
                this.success_records_list = [];
                this.failed_record_list = [];
            },
            submitFile() {
                if (this.file == null) {
                    alert("Please select the file!");
                } else {
                    this.overlay = true;
                    let formData = new FormData();
                    //console.log(this.file.size)
                    formData.append("file", this.file);

                    //console.log(formData)
                    axios
                        .post("OutstandingFees/importOutstandingFees", formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        })
                        .then((res) => {
                            if (res.data.status == "NO") {
                                this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                            } else {
                                this.success_records_list = res.data.success_records_list;
                                this.failed_record_list = res.data.failed_record_list;
                                this.overlay = false;
                                this.row = "success";
                                this.showSnackbar("#4caf50", "Data Imported Successfully..."); // show snackbar on success
                            }
                        })
                        .catch(function () {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        })
                        .finally(() => {
                            this.overlay = false;
                            this.file = null;
                        });
                    //     }
                }
            },
            getDetails() {
                this.new_outstanding_field = true;
                // alert("in getDetails");
                // alert(this.selected_children.id);
                const formData = {
                    child: this.registration_no.registration_number,
                    ay: this.ay,
                };
                axios
                    .post("/AccountingAndFees/getOutstandingFeesDetails", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.status == "Fail") {
                                this.showSnackbar("#b71c1c", res.data.status_reason);
                                this.show = false;
                                return false;
                            }
                            if (res.data.status == "SUCCESS") {
                                this.get_outstanding_fees_list = res.data.get_outstanding_fees_list;
                                this.already_selected_component_selection_list = res.data.already_selected_component_selection_list;
                                this.current_ay = res.data.current_ay;
                                this.show = true;
                            } else if (res.data.flag == "NO") {
                                this.showSnackbar("#b71c1c", res.data.snackbar);
                            }
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },

            assignOutFees() {
                this.proceed_btn_load = true;
                const formData = {
                    ay: this.ay,
                    child: this.registration_no.registration_number,
                    out_amount: this.out_fees,
                };
                axios
                    .post("/AccountingAndFees/putOutstandingFeesSelection", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.flag == "YES") {
                                this.showSnackbar("#4caf50", res.data.status_reason);
                                this.getDetails();
                            }
                            if (res.data.flag == "NO") {
                                this.showSnackbar("#b71c1c", res.data.status_reason);
                            }
                            // this.get_outstanding_fees_list =
                            //   res.data.get_outstanding_fees_list;
                            //   this.current_ay = res.data.current_ay
                            // this.show = true;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                        this.out_fees = null;
                        this.ay = null;
                        this.proceed_btn_load = false;
                        this.loader = false;
                        //alert("done")
                    });
            },

            putEntry(amount, out_fees_id) {
                // alert('Put entry')
                // alert('slected' +this.selected_install)
                const formData = {
                    out_amount: amount,
                    child: this.registration_no.registration_number,
                    id: out_fees_id,
                };
                axios
                    .post("/AccountingAndFees/updateStudentOutstandingFees", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.status == "Success") {
                                this.showSnackbar("#4caf50", res.data.status_reason);
                                this.getDetails();
                            }
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },


            updateStudentOutstandingfees_due_date_fine(due_date, out_fees_id){
                const formData = {
                    due_date: due_date,
                    child: this.registration_no.registration_number,
                    id: out_fees_id,
                };
                axios
                    .post("/AccountingAndFees/updateStudentOutstandingfees_due_date_fine", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.status == "Success") {
                                this.showSnackbar("#4caf50", res.data.status_reason);
                                this.getDetails();
                            }
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },

        mounted() {
            //alert("this.s3url::"+this.s3url)
            // axios
            //     .post("/AccountingAndFees/getChildList")
            //     .then((res) => {
            //         if (res.data.msg == "200") {
            //             if ((res.data.status = "SUCCESS")) {
            //                 this.children = res.data.learners;
            //                 console.log(res.data.academic_year_list);
            //                 this.academic_year_list = res.data.academic_year_list;
            //             } else {
            //                 alert(res.data.status_reason);
            //             }
            //         }
            //     })
            //     .catch((error) => {
            //         window.console.log(error);
            //     })
            //     .finally(() => {
            //         //close loader
            //         this.loader = false;
            //         //alert("done")
            //     });
             axios
                .post("/admission/getAllStudents_for_account")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.stud_list = res.data.stud_list;
                        this.academic_year_list = res.data.academic_year_list;
                        this.selected_ay = res.data.current_ay;
                    } else {
                        alert("Somthing went wrong!!!");
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        computed: {
            searchByTitleOrDescription() {
                /*function compare(a, b) {
        if (a.title < b.title || a.description < b.description) return -1;
        if (a.title > b.title || a.description < b.description) return 1;
        return 0;
      }
      if (!this.search) return this.child_notice.notices.sort(compare);*/

                return this.child_notice.notices.filter((tbdata) => {
                    return tbdata.title.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 || tbdata.description.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
                });
            },
        }, // end of computed()
    };
</script>

<style scoped>
input[type="date"] {
      width: 50%;
      display: inline-block;
      padding: 0.3rem;
      border: 1px solid gray;
      border-radius: 30px;
      box-sizing: border-box;
      padding-top: none !important;
      margin-top: none !important;
  }

    .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
        font-size: 80%;
    }
    .downbtn {
        float: right;
    }
    .even {
        background-color: whitesmoke;
    }
    .odd {
        background-color: white;
    }
    .mytable /deep/ thead th {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
